import { useContext } from "react";
import Button from "../components/Button";
import TextInput from "../components/TextInput";
import { ReactComponent as IllusStep } from "../img/illustrations/recap.svg";
import { ReactComponent as IconPen } from "../img/pen.svg";
import { useSwiper } from "swiper/react";
import SimulationContext from "../contexts/Simulation";

const RecapStep = () => {
  const swiper = useSwiper();
  const [simParams] = useContext(SimulationContext);

  const handleNext = () => {
    document.getElementById('loader').classList.add('active');
    setTimeout(() => { 
      document.getElementById('loader').classList.remove('active');
      swiper.slideNext(); 
    }, 3500);
  }

  return (
    <div className="content recap">
      <IllusStep className="main-illus"/>
      <h3>Votre projet solaire en résumé</h3>
      <div className="sub">Tout est prêt ? Vérifiez vos infos avant de passer à l'estimation.</div>
      <TextInput 
        variant="recap" 
        readonly={true} 
        Before={() => <>Lieu : </>} 
        After={() => <IconPen onClick={() => swiper.slideTo(1)}/>}
        value={`${simParams.location?.zip_code} ${simParams.location?.name}`}
      />
      <TextInput 
        variant="recap" 
        readonly={true} 
        Before={() => <>Conso estimée : </>}
        After={() => <IconPen onClick={() => swiper.slideTo(2)}/>}
        value={`${simParams.consos[0]} kWh - ${simParams.consos[1]} kWh - ${simParams.consos[2]} kWh`}
      />
      <TextInput 
        variant="recap" 
        readonly={true} 
        Before={() => <>Présence en journée : </>} 
        After={() => <IconPen onClick={() => swiper.slideTo(3)}/>}
        value={simParams.infos?.daily_presence ? 'Oui' : 'Non'}
      />
      <Button variant='yellow' onclick={handleNext}>Valider</Button>
    </div>
  )
}

export default RecapStep;